import React from 'react';
import { useNavigate } from 'react-router-dom';

const SITable = ({ data, page }) => {
    const Navigate = useNavigate();

    return (
        <table className="w-full h-full max-w-[1200px] mx-auto text-sm text-left shadow-md md:rounded-lg overflow-x-scroll md:overflow-hidden">
            <thead className="text-xs text-white uppercase">
                <tr className="bg-red-500 border-b">
                    <th scope="row" className="px-6 py-4 font-bold text-white">No.</th>
                    <th className="px-6 py-4">Organization</th>
                    <th className="px-6 py-4">Category</th>
                    <th className="px-6 py-4">Contact Person</th> {/* Added contact*/}
                    <th className="px-6 py-4">Mode</th> {/* Added */}
                    <th className="px-6 py-4">Date & Time</th>
                    <th className="px-6 py-4">KMA Member</th>
                </tr>
            </thead>
            <tbody>
                {data?.map((item, i) => (
                    <tr
                        key={item._id || i}
                        onClick={() => Navigate(`/admin/application/${item?.formName}/${item?._id}`)}
                        className="bg-white border-b hover:bg-gray-50 text-black cursor-pointer"
                    >
                        <td className="px-6 py-4">{(page - 1) * 10 + i + 1}</td>
                        
                        <td className="px-6 py-4 capitalize font-medium">
                            {item?.basicInformation?.organizationName || "N/A"}
                        </td>
                        
                        <td className="px-6 py-4 capitalize">
                            {item?.basicInformation?.category || "-"}
                        </td>

                        {/* Contact Details Column */}
                        <td className="px-6 py-4 text-xs max-w-[200px] truncate">
                            {item?.basicInformation?.contactDetails || "N/A"}
                        </td>

                        {/* Payment Mode Column */}
                        <td className="px-6 py-4 font-semibold text-black-600">
                            {item?.paymentDetails?.mode || "Online"}
                        </td>
                        
                        <td className="px-6 py-4 text-xs">
                            {new Date(item?.createdAt).toLocaleString()}
                        </td>
                        
                        <td className="px-6 py-4 capitalize">
                            {item?.paymentDetails?.isKmaMember === true || item?.paymentDetails?.isKmaMember === "true" ? "Yes" : "No"}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default SITable;